<script>
  import { onMount, createEventDispatcher } from "svelte";

  import { getPublicClient, writeContract } from "@wagmi/core";

  import { chainExplorer } from "../stores.js";
  import { getABI, getContractValue } from "../utils.js";

  export let chain;
  export let address;

  let amIPrivate = false;

  let toggling = false;
  let feedback;
  let txHash;

  const init = async () => { amIPrivate = await getContractValue(chain, address, "amIPrivate")}

  const toggle = async () => {
    toggling = true;
    try {
      const { hash } = await writeContract({
        chainId: chain, address, abi: await getABI(address, chain), functionName: 'togglePrivacy'
      });
      txHash = hash;
    } catch (err) {
      if (err.shortMessage === 'User rejected the request.') {
        dispatch('user-cancel');
        new CustomEvent('user-cancel');
        toggling = undefined;
      } else {
        console.log(err)
        dispatch('error', err);
        new CustomEvent('error', { detail: err });
      }
      return;
    }

    dispatch('hashed', txHash);
    new CustomEvent('hashed', { detail: txHash });
    const receipt = await getPublicClient().waitForTransactionReceipt({ hash: txHash });
    amIPrivate = !amIPrivate;
    dispatch('toggled', receipt)
    new CustomEvent('toggled', { detail: receipt });
    txHash = undefined;
    toggling = undefined;
  }

  onMount(init);

  const dispatch = createEventDispatcher();
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<!-- svelte-ignore a11y-no-static-element-interactions -->
<span class="lt-privacy" on:click={ toggle }>
  {#if toggling}
    <span class="toggling"></span>
  {:else if feedback}
    <span class="feedback">{ feedback }</span>
  {:else if txHash}
    <a href="{ $chainExplorer.url }/tx/{ txHash }" target="_blank">View tx</a>
  {:else}
    {#if amIPrivate}
      <slot name="private">&#128274;</slot>
    {:else}
      <slot name="public">&#128275;</slot>
    {/if}
  {/if}
</span>